module.exports = __webpack_public_path__ + "img/bg_intro_1_4_mb.95ffec67.svg";